/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Curve_Template_PolarisInputs */



/**
* | output |
* | --- |
* | "Polaris" |
*
* @param {Leveling_Curve_Template_PolarisInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_curve_template_polaris = /** @type {((inputs?: Leveling_Curve_Template_PolarisInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Curve_Template_PolarisInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Polaris")
	return /** @type {LocalizedString} */ ("Polaris")
});